import { Maximize2, Minimize2 } from "lucide-react";
import { useLayoutEffect, useRef, useState } from "react";
import type { ReactNode } from "react";
import { COLLAPSED_OUTPUT_HEIGHT } from "./chat/ToolResultView.utils";

export function ExpandableOutput({ children }: { children: ReactNode }) {
  const outputRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [isLong, setIsLong] = useState(false);

  useLayoutEffect(() => {
    const output = outputRef.current;
    if (!output) return;

    const measure = () => {
      setIsLong(output.scrollHeight > COLLAPSED_OUTPUT_HEIGHT);
    };

    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(output);
    return () => observer.disconnect();
  }, [children]);

  return (
    <div className="min-w-0">
      <div
        ref={outputRef}
        className={expanded ? "min-w-0" : "max-h-80 min-w-0 overflow-y-auto"}
      >
        {children}
      </div>
      {isLong && (
        <button
          type="button"
          className="mt-2 inline-flex items-center gap-1 rounded-lg px-2 py-1 text-[11px] font-semibold text-lumen-700 transition hover:bg-lumen-50 dark:text-lumen-300 dark:hover:bg-lumen-900/30"
          onClick={() => setExpanded((value) => !value)}
        >
          {expanded ? <Minimize2 size={12} /> : <Maximize2 size={12} />}
          {expanded ? "Show less" : "Expand output"}
        </button>
      )}
    </div>
  );
}
